"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationPreferencesItem = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _components = require("../../components");
var _excluded = ["phoneChangeDescription", "phoneChangeCta", "onPhoneChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var Switcher = function Switcher(_ref) {
  var phoneChangeDescription = _ref.phoneChangeDescription,
    phoneChangeCta = _ref.phoneChangeCta,
    onPhoneChange = _ref.onPhoneChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var switcher = /*#__PURE__*/_react.default.createElement(_components.Toggle, props);
  if (props.disabled) {
    return /*#__PURE__*/_react.default.createElement(_components.Tooltip, {
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "text-center"
      }, phoneChangeDescription, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
        className: "mt-[8px]",
        onClick: onPhoneChange
      }, phoneChangeCta))
    }, switcher);
  }
  return switcher;
};
var NotificationPreferencesItem = function NotificationPreferencesItem(_ref2) {
  var checked = _ref2.checked,
    description = _ref2.description,
    disabled = _ref2.disabled,
    onChange = _ref2.onChange,
    title = _ref2.title,
    phoneChangeDescription = _ref2.phoneChangeDescription,
    phoneChangeCta = _ref2.phoneChangeCta,
    onPhoneChange = _ref2.onPhoneChange;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-notification-preference-item flex items-start w-full"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full mr-[24px]"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-subtitle-sm-regular mb-[8px] text-black"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-light text-black"
  }, description)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Switcher, {
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    phoneChangeDescription: phoneChangeDescription,
    phoneChangeCta: phoneChangeCta,
    onPhoneChange: onPhoneChange
  })));
};
exports.NotificationPreferencesItem = NotificationPreferencesItem;
NotificationPreferencesItem.propTypes = {
  checked: _propTypes.default.bool,
  description: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  title: _propTypes.default.string,
  onPhoneChange: _propTypes.default.func.isRequired
};